/*! Remodal - v0.1.1 - 2014-02-23
 * https://github.com/VodkaBears/remodal
 * Copyright (c) 2014 VodkaBears; */
window.REMODAL_GLOBALS = {
  NAMESPACE: 'modal',
  DEFAULTS: {
    hashTracking: false
  }
};
! function (a)
{
	"use strict";

	function b(b, c)
	{
		this.settings = a.extend(
		{}, e, c), this.modal = b, this.buildDOM(), this.addEventListeners(), this.index = f.push(this) - 1, this.busy = !1
	}
	var c, d = "remodal",
		e = {
			hashTracking: false
		},
		f = [],
		g = function (a)
		{
			var b = a.css("transition-duration") || a.css("-webkit-transition-duration") || a.css("-moz-transition-duration") || a.css("-o-transition-duration") || a.css("-ms-transition-duration") || 0,
				c = a.css("transition-delay") || a.css("-webkit-transition-delay") || a.css("-moz-transition-delay") || a.css("-o-transition-delay") || a.css("-ms-transition-delay") || 0;
			return 1e3 * (parseFloat(b) + parseFloat(c))
		},
		h = function ()
		{
			var a = document.createElement("div");
			a.style.visibility = "hidden", a.style.width = "100px", document.body.appendChild(a);
			var b = a.offsetWidth;
			a.style.overflow = "scroll";
			var c = document.createElement("div");
			c.style.width = "100%", a.appendChild(c);
			var d = c.offsetWidth;
			return a.parentNode.removeChild(a), b - d
		},
		i = function ()
		{
			a("html, body").addClass(d + "_lock"), a(document.body).css("padding-right", "+=" + h())
		},
		j = function ()
		{
			a("html, body").removeClass(d + "_lock"), a(document.body).css("padding-right", "-=" + h())
		};
	b.prototype.buildDOM = function ()
	{
		this.body = a(document.body), this.bg = a("." + d + "-bg"), this.modalClose = a("<a data-remodal-options='hashTracking: false'>").addClass(d + "-close"), this.overlay = a("<div>").addClass(d + "-overlay"), this.modal.hasClass(d) || this.modal.addClass(d), this.modal.css("visibility", "visible"), this.modal.append(this.modalClose), this.overlay.append(this.modal), this.body.append(this.overlay), this.confirm = this.modal.find("." + d + "-confirm"), this.cancel = this.modal.find("." + d + "-cancel");
		var b = g(this.overlay),
			c = g(this.modal),
			e = g(this.bg);
		this.td = c > b ? c : b, this.td = e > this.td ? e : this.td
	}, b.prototype.addEventListeners = function ()
	{
		this.modalClose.bind("click." + d, function (a)
		{
			a.preventDefault(), this.close()
		}.bind(this)), this.cancel.bind("click." + d, function (a)
		{
			a.preventDefault(), this.modal.trigger("cancel"), this.close()
		}.bind(this)), this.confirm.bind("click." + d, function (a)
		{
			a.preventDefault(), this.modal.trigger("confirm"), this.close()
		}.bind(this)), a(document).bind("keyup." + d, function (a)
		{
			27 === a.keyCode && this.close()
		}.bind(this)), this.overlay.bind("click." + d, function (b)
		{
			var c = a(b.target);
			c.hasClass(d + "-overlay") && this.close()
		}.bind(this))
	}, b.prototype.open = function ()
	{
		if (!this.busy)
		{
			this.busy = !0, this.modal.trigger("open");
			var a = this.modal.attr("data-" + d + "-id");
			a && this.settings.hashTracking && (location.hash = a), c && c !== this && (c.overlay.hide(), c.body.removeClass(d + "_active")), c = this, i(), this.overlay.show(), setTimeout(function ()
			{
				this.body.addClass(d + "_active"), setTimeout(function ()
				{
					this.busy = !1, this.modal.trigger("opened")
				}.bind(this), this.td + 50)
			}.bind(this), 25)
		}
	}, b.prototype.close = function ()
	{
		this.busy || (this.busy = !0, this.modal.trigger("close"), this.settings.hashTracking && this.modal.attr("data-" + d + "-id") === location.hash.substr(1) && (location.hash = ""), this.body.removeClass(d + "_active"), console.log(this.td), setTimeout(function ()
		{
			this.overlay.hide(), j(), this.busy = !1, this.modal.trigger("closed")
		}.bind(this), this.td + 50))
	}, a && (a.fn[d] = function (c)
	{
		return this.each(function (e, f)
		{
			var g = a(f);
			if (!g.data(d))
			{
				var h = new b(g, c);
				g.data(d, h.index)
			}
		})
	}), a(document).on("click", "[data-" + d + "-target]", function (b)
	{
		b.preventDefault();
		var c = b.currentTarget,
			e = c.getAttribute("data-" + d + "-target"),
			g = a("[data-" + d + "-id=" + e + "]");
		f[g.data(d)].open()
	}), a(document).find("." + d).each(function (b, c)
	{
		var e = a(c),
			f = e.data(d + "-options");
		f || (f = {}), e[d](f)
	});
	var k = function (b, e)
	{
		var g = location.hash.replace("#", "");
		if ("undefined" == typeof e && (e = !0), g)
		{
			var h = a("[data-" + d + "-id=" + g + "]");
			if (h.length)
			{
				var i = f[h.data(d)];
				i && i.settings.hashTracking && i.open()
			}
		}
		else e && c && !c.busy && c.settings.hashTracking && c.close()
	};
	a(window).bind("hashchange." + d, k), k(null, !1)
}(window.jQuery || window.Zepto);